<!-- page header -->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Oase
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home"/>
  </ion-toolbar>
</ion-header>
<!-- select the date of the menus -->
<ion-list mode="md" lines="full">
  <ion-item>
    <ion-label>Date</ion-label>
    <ion-select interface="popover" [(ngModel)]="dateSelector" (ionChange)="switchDate()" placeholder="Select One">
      <ion-select-option value="today">{{today | date: 'dd.MM.yyyy'}}</ion-select-option>
      <ion-select-option value="tomorrow">{{tomorrow | date: 'dd.MM.yyyy'}}</ion-select-option>
      <ion-select-option value="dayaftertomorrow">{{dayaftertomorrow | date: 'dd.MM.yyyy'}}</ion-select-option>
    </ion-select>
  </ion-item>
</ion-list>

<!-- select the menu -->
<div *ngIf="!isWeekend">
  <div *ngIf="!isNormalHoliday">
    <ion-segment fill="outline" color="medium" [(ngModel)]='menuTab'>
      <ion-segment-button value="lunch">
        <ion-label>Lunch</ion-label>
      </ion-segment-button>
      <ion-segment-button value="business">
        <ion-label>Business</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>
</div>

<ion-content>
  <!-- Debug Info -->
  <ion-card *ngIf="showDebugInfo" color="warning">
    <ion-card-header>
      <ion-card-title>Debug Info</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <p><strong>Date:</strong> {{date | date: 'dd.MM.yyyy'}}</p>
      <p><strong>Day of Week:</strong> {{date.getDay()}} (0=Sunday, 1=Monday, etc.)</p>
      <p><strong>Week Index:</strong> {{selectedDay}} (0=Monday, 4=Friday)</p>
      <p><strong>Is Weekend:</strong> {{isWeekend}}</p>
      <p><strong>Menu Tab:</strong> {{menuTab}}</p>
      <p><strong>Lunch Menus Count:</strong> {{menuslunch.length}}</p>
      <p><strong>Business Menus Count:</strong> {{menusbusiness.length}}</p>
      <p><strong>Business Available:</strong> {{menuBusinessAvailable}}</p>
      <div *ngFor="let menu of menuslunch">
        <p><strong>{{menu.title}}:</strong> {{menu.main ? 'Has main' : 'No main'}}, {{menu.starter ? 'Has starter' : 'No starter'}}, {{menu.dessert ? 'Has dessert' : 'No dessert'}}</p>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- switch the menu -->
  <div *ngIf="!isWeekend">
    <div *ngIf="!isNormalHoliday">
      <div [ngSwitch]="menuTab">
        <!-- Lunch Menus Tab -->
        <div *ngSwitchCase="'lunch'">
          <ion-card *ngFor="let menu of menuslunch">
            <ion-card-header>
              <ion-card-title>{{menu.title}}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-text *ngIf="menu.starter" class="ion-padding">
                <h2 class="ion-text-uppercase"><strong>Starter</strong></h2>
                <h2 [innerHTML]="menu.starter"></h2>
              </ion-text>
              <ion-text *ngIf="menu.main" class="ion-padding">
                <h2 *ngIf="menu.starter" class="ion-text-uppercase"><strong>Main</strong></h2>
                <h2 [innerHTML]="menu.main">{{menu.main}}</h2>                
              </ion-text>
              <ion-text *ngIf="!menu.main && !menu.dessert" class="ion-padding">Currently not available</ion-text>
              <ion-text *ngIf="menu.dessert" class="ion-padding">
                <h2 *ngIf="menu.starter" class="ion-text-uppercase"><strong>Dessert</strong></h2>
                <h2 [innerHTML]="menu.dessert"></h2>
              </ion-text>
              <ion-text class="ion-text-right ion-padding">
                <h2 *ngIf="menu.price">{{menu.price | number:'1.2-2'}} CHF</h2>
                <h2 *ngIf="menu.dprice">{{menu.dprice | number:'1.2-2'}} CHF</h2>
              </ion-text>
            </ion-card-content>
          </ion-card>
          
          <!-- opening hours of the OASE restaurant-->

        </div>
        <!-- Business Lunch Tab -->
        <div *ngSwitchCase="'business'">
          <ng-container *ngIf="!menuBusinessAvailable">
            <ion-card>
              <ion-card-content>
                <ion-card-title>Menu not available.</ion-card-title>
              </ion-card-content>
            </ion-card>
          </ng-container>
          <ng-container *ngIf="menuBusinessAvailable">
            <ion-card class="ion-text-center" *ngFor="let menu of menusbusiness">
              <ion-card-header>
                <ion-card-title>{{menu.title}}</ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <div class="businessmenu">
                  <hr>
                  <ion-text *ngIf="menu.starter" class="ion-padding">
                    <h2 [innerHTML]="menu.starter"></h2>
                  </ion-text>
                  <hr>
                  <ion-text *ngIf="menu.main" class="ion-padding">
                    <h2 [innerHTML]="menu.main"></h2>
                  </ion-text>
                  <hr>
                  <ion-text *ngIf="menu.dessert" class="ion-padding">
                    <h2 [innerHTML]="menu.dessert"></h2>
                  </ion-text>
                  <ion-text class="ion-padding">
                    <h2><small>Complete menu: {{menu.price | number:'1.2-2'}} CHF</small></h2>
                  </ion-text>
                </div>

                <!-- business lunch wines -->
                <!-- <div class="businessmenu" *ngFor="let wine of menuswines">
                  <ion-text class="ion-padding">
                    <h2><strong>Our regional wine recommendation</strong></h2>
                  </ion-text>
                  <hr>
                  <ion-text class="ion-padding">
                    <h4><strong>White wine</strong></h4>
                  </ion-text>
                  <ion-text *ngIf="wine.starter" class="ion-padding">
                    <h2 [innerHTML]="wine.starter"></h2>
                  </ion-text>
                  <ion-text class="ion-padding">
                    <h2><small>per dl {{wine.sprice}} CHF</small></h2>
                  </ion-text>
                  <hr>
                  <ion-text class="ion-padding">
                    <h4><strong>Red wine</strong></h4>
                  </ion-text>
                  <ion-text *ngIf="wine.main" class="ion-padding">
                    <h2 [innerHTML]="wine.main"></h2>
                  </ion-text>
                  <ion-text class="ion-padding">
                    <h2><small>per dl {{wine.price}} CHF</small></h2>
                  </ion-text>
                </div> -->

              </ion-card-content>
            </ion-card>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- holiday view -->
    <div *ngIf="holiday">
      <ion-card>
        <ion-card-header>
          <ion-card-subtitle>Holiday</ion-card-subtitle>
          <ion-card-title>{{holiday.title}}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <span [innerHTML]="holiday.html"></span>
        </ion-card-content>
      </ion-card>
    </div>



    <!-- Opening Hours -->
    <ion-card color="light">
      <ion-card-header>
        <ion-card-title>Opening Hours</ion-card-title>
        <ion-card-subtitle>Mon. - Fri.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-list mode="ios" lines="full">
          <ion-item color="light" *ngFor="let openingHour of openingHours">
            <ion-label class="ion-textwrap">
              <ion-text>
                <h2>{{openingHour.title}}</h2>
              </ion-text>
              <ion-text color="medium">
                <h2>{{openingHour.value}}</h2>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
    
</div> 

  <div *ngIf="isWeekend">
    <!-- Food Truck Information -->
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>Information</ion-card-subtitle>
        <ion-card-title>Catering on weekends and holidays with SLS operation</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        Meeting the stable demand, the catering on weekends and holidays provided by external "Food Trucks" will
        transition from the pilot to the operation phase in 2019. On weekends and holidays with SLS operation, a
        Food
        Truck will offer lunch at 11:00 - 12:30 and dinner at 18:30 - 19:30 in front of the cafeteria timeout. The
        organisation is taken over by the Oase team.
      </ion-card-content>
    </ion-card>
    <!-- Types of Food Trucks -->
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>Test the Food trucks during the weekends!</ion-card-subtitle>
        <ion-card-title>The Food Trucks</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-list mode="ios" lines="full">
          <ion-item>
            <ion-label class="ion-textwrap">
              <ion-text>
                <h2><a target="_blank" href="https://www.grillin-me-softly.ch/">Grillin' me softly
                  <ion-icon name="open-outline"></ion-icon>
                </a></h2>
              </ion-text>
              <ion-text color="medium">
                <h2>Neuenhof - "Grillin' me softly" für schmackhafte und gesunde Verpflegung über Mittag und abends.
                  Qualität die man schmeckt.</h2>
              </ion-text>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-textwrap">
              <ion-text>
                <h2><a target="_blank" href="http://www.keagheinz.com/">Keagheinz
                  <ion-icon name="open-outline"></ion-icon>
                </a></h2>
              </ion-text>
              <ion-text color="medium">
                <h2>Hausen - Thaifood</h2>
              </ion-text>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-textwrap">
              <ion-text>
                <h2><a target="_blank" href="http://www.tasteofparadise.ch/catering-and-more.html">Taste of Paradise
                  <ion-icon name="open-outline"></ion-icon>
                </a></h2>
              </ion-text>
              <ion-text color="medium">
                <h2>Zürich - Exotisches Essen, Ayurveda, Vegan und Fingerfood
                  <ion-icon name="open-outline"></ion-icon>
                </h2>
              </ion-text>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label class="ion-textwrap">
              <ion-text>
                <h2><a target="_blank" href="http://www.wakara.ch/">Wakara Karaage
                  <ion-icon name="open-outline"></ion-icon>
                </a></h2>
              </ion-text>
              <ion-text color="medium">
                <h2>Karaage, die saftigen Pouletknusperli aus Japan. Frisch zubereitet mit schweizer Fleisch, nach
                  original japanischem Rezept.</h2>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
    <!-- Foodtruck Schedule -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Schedule</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <a title="Link to the Foodtruck schedule" href="https://www.psi.ch/en/useroffice/food-and-catering"
           target="_blank" rel="noopener noreferrer">
          <ion-button shape="round" color="dark">
            <ion-icon slot="start" name="calendar"></ion-icon>
            Open foodtruck schedule
          </ion-button>
        </a><br>
      </ion-card-content>
    </ion-card>
    <!-- Pizza Service Information -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Pizza Service</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        During weekends and holidays Salvatore Ramundo offers a Pizza service. Just visit him close to the Guest
        House.
        Pre-orders can be submitted by phone: <a href="tel:+41765681078">+41 76 568 10 78</a>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
